import React from 'react';
import styled, { css } from 'styled-components';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    cyan?: boolean;
    fullWidth?: boolean;
}

const StyledButton = styled.button<ButtonProps>`
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: bold;
  padding: 0.5rem 1rem;
  //color: white;
  outline: none;
  cursor: pointer;
  background: var(--bg-list);
  color: var(--text-bright);

  &:hover {
    background: var(--border-color);
  }

  ${props =>
          props.cyan &&
          css`
            background: var(--primary-accent);
            &:hover {
              background: var(--primary-accent-hover);
            }
          `
  }

  ${props =>
          props.fullWidth &&
          css`
            width: 100%;
          `
  }
`;

const Button: React.FC<ButtonProps> = (props) => <StyledButton {...props} />;

export default Button;

